type Params = {
  stableToDollar?: boolean;
};

export const concatCurrencyToAmount = (
  amount: number | string,
  currency: string,
  params: Params = {},
): string => {
  const { stableToDollar = true } = params;
  const parsedCurrency = stableToDollar && currency.toLowerCase() === 'usdt' ? '$' : currency;

  if (parsedCurrency === '$') {
    return `$${amount}`;
  }

  return `${amount} ${parsedCurrency}`;
};
